import React from 'react'
import {
  IIdentityInformation,
  IIdentityInformations,
} from '../../interfaces/Identity'
import IdentityInformation from './IdentityInformation'
import { convertNumericDateToString } from '../../services/utils'

const IdentityInformations = ({
  folder,
  existingIdentity,
  register,
}: IIdentityInformations) => {
  const {
    civilite,
    nationalite_principale,
    nationalite_secondaire,
    sexe,
    prenom1,
    prenom2,
    prenom3,
    nom_patronimique,
    date_naissance,
    lieu_naissance,
    commune_naissance,
    departement_naissance,
    pays_naissance,
  } = folder
  if (existingIdentity !== '1' && existingIdentity !== '') {
    return <></>
  }
  const datas: Array<IIdentityInformation> = [
    {
      title: 'Prénoms',
      value: [prenom1, prenom2, prenom3],
      personneInfo: {
        civilite,
        sexe,
        prenom1,
        prenom2,
        prenom3,
        nationalite_principale,
        nationalite_secondaire,
      },
    },
    {
      title: 'Nom',
      value: [nom_patronimique],
      personneInfo: { nom_patronimique },
    },
    {
      title: 'Date de naissance',
      value: [convertNumericDateToString(date_naissance)],
      personneInfo: { date_naissance },
    },
    {
      title: 'Lieu de naissance',
      value: [lieu_naissance],
      personneInfo: {
        lieu_naissance,
        commune_naissance,
        departement_naissance,
        pays_naissance,
      },
    },
  ]
  return (
    <div className="colMd12 mb5">
      {React.Children.toArray(
        datas.map((data: IIdentityInformation) => (
          <IdentityInformation {...data} register={register} />
        ))
      )}
      {existingIdentity === '1' && (
        <div className="backgroundSuccessInfo row ml0 mt2 pt1 pb1 pl1">
          <p>
            Les données présentées correspondant à votre identité, nous vous
            invitons à poursuivre vers l'étape suivante.
          </p>
        </div>
      )}
    </div>
  )
}

export default IdentityInformations
